import { type ZodType, z } from "zod";
import { FeroResponseMetadata } from "./response-meta.js";

/**
 * A generic response object, which allows us to pass in the schema for the body of the response
 * @param bodySchema A
 */
export const FeroResponseBody = <T extends ZodType>(bodySchema: T) =>
  z.object({
    status: z.literal("success"),
    data: bodySchema,
    meta: FeroResponseMetadata,
  });
